import { axios, serializeParams } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';
import { saveToLocalStorage } from '@/lib/helpers';
import { api } from '@/lib/trpc/client';

function getTrcpErrorMessage(error) {
  return error?.message || error?.data?.code;
}

export const saveSalesOrdersAdminActiveFilters = createAction(
  'sales-orders-admin/active-filters/save'
);

export const setSalesOrdersAdminActiveFilters = (filterUpdate) => (dispatch, getState) => {
  const state = getState();
  const salesOrdersAdminState = state.salesOrdersAdmin;
  const { activeFilters } = salesOrdersAdminState;

  let newFilters = {};

  if (filterUpdate === null) {
    newFilters = {
      seasons: [],
      quarters: [],
      brands: [],
      groups: [],
      types: [],
      status: [],
      deadline: '',
    };
  } else {
    newFilters = {
      ...activeFilters,
      ...filterUpdate,
    };
  }

  saveToLocalStorage('salesOrdersAdminActiveFilters', newFilters);
  dispatch(saveSalesOrdersAdminActiveFilters(newFilters));
};

export const salesOrdersAdminOrdersFetchStarted = createAction('sales-orders-admin/orders/started');

export const salesOrdersAdminOrdersFetchFailed = createAction('sales-orders-admin/orders/failed');

export const salesOrdersAdminOrdersFetchSucceeded = createAction(
  'sales-orders-admin/orders/succeeded'
);

export const setSalesOrdersAdminOrders = createAction('sales-orders-admin/orders/set');

/**
 * Get orders
 *
 * @param {searchFilters}
 * @returns {void}
 */
export const getSalesOrdersAdminOrders = (searchFilters) => (dispatch, getState) => {
  dispatch(salesOrdersAdminOrdersFetchStarted());

  const state = getState();
  const userState = state.user;
  const { activeChain } = userState;

  const requestParams = {
    seasons: searchFilters.seasons ? searchFilters.seasons : undefined,
    quarters: searchFilters.quarters ? searchFilters.quarters : undefined,
    brands: searchFilters.brands ? searchFilters.brands : undefined,
    groups: searchFilters.groups ? searchFilters.groups : undefined,
    types: searchFilters.types ? searchFilters.types : undefined,
    status: searchFilters.status ? searchFilters.status : undefined,
    deadline: searchFilters.deadline ? searchFilters.deadline : undefined,
  };

  return api.salesOrders.getSalesOrdersAdminOrders
    .query({
      ...requestParams,
      chain: activeChain,
    })
    .then(
      ({ result }) => {
        dispatch(setSalesOrdersAdminOrders(result));
        dispatch(salesOrdersAdminOrdersFetchSucceeded(result));
      },
      (error) => dispatch(salesOrdersAdminOrdersFetchFailed(getTrcpErrorMessage(error)))
    );
};
